export default __webpack_public_path__ + "static/media/SO.fbadbe4c.svg";